module.exports = __webpack_public_path__ + "media/images/web_suite/dashboard/tours_icon-6fc955ef7f2e51b3cfa1506228e49b65.png";